import styled from 'styled-components'

export const Box = styled.footer`
  z-index: 1000;
  background: ${(p) => p.theme.uiKit.colors.global.general.main};
  height: 66px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 50px 0 50px;
  border-top: 1px solid ${(p) => p.theme.uiKit.colors.global.grey.grey300};
`
